import React from 'react'

import { CaretIcon } from './icons'
import { RoomRow } from './RoomRow'
import { Caret, GroupBody, GroupHeaderButton, GroupSection, GroupTitle } from './styles'

import type { RoomGroup } from '../../models/rooms'

type RoomGroupSectionProps = {
    group: RoomGroup
    attachedRoomId: string | null
    attachingRoomId: string | null
    onToggleGroup: (groupId: string) => void
    onAttachRoom: (roomId: string) => void
}

export function RoomGroupSectionItem({
    group,
    attachedRoomId,
    attachingRoomId,
    onToggleGroup,
    onAttachRoom,
}: RoomGroupSectionProps) {
    return (
        <GroupSection>
            <GroupHeaderButton type="button" aria-expanded={!group.collapsed} onClick={() => onToggleGroup(group.id)}>
                <GroupTitle>{group.title}</GroupTitle>
                <Caret $expanded={!group.collapsed}>
                    <CaretIcon />
                </Caret>
            </GroupHeaderButton>

            {!group.collapsed ? (
                <GroupBody>
                    {group.rooms.map((room) => (
                        <RoomRow
                            key={room.id}
                            room={room}
                            isAttached={attachedRoomId === room.id}
                            isAttaching={attachingRoomId === room.id}
                            onAttach={onAttachRoom}
                        />
                    ))}
                </GroupBody>
            ) : null}
        </GroupSection>
    )
}
